import React, { useState, useEffect } from "react";
import { Row, Col, Button, Space } from "antd";
import { PlusCircleOutlined } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import QuotesList from "./QuotesList";
import { FormattedMessage } from "react-intl";
import CreateQuote from "features/Dashboard/CreateQuote";
import {
  resetClientDetailsById,
  resetEstimateById,
  resetPartnerClientDetailsById,
} from "features/Clients/ClientsSlice";
import { useDispatch } from "react-redux";
function Quotes() {
  const dispatch = useDispatch();
  const [openQuoteModel, setOpenQuoteModel] = useState(false);

  useEffect(() => {
    dispatch(resetClientDetailsById());
    dispatch(resetPartnerClientDetailsById());
    dispatch(resetEstimateById());
  }, []);

  return (
    <>
      <div className="medispamain" style={{ position: "relative" }}>
        <div className="main-area">
          <div className="title-part">
            <Row align="middle" gutter={[16, 16]}>
              <Col xs={12} md={12} lg={12}>
                <h4>
                  <FormattedMessage id="Dashboard.Quotes" />
                </h4>
                <p className="mt-5px">
                  <FormattedMessage id="Quotes.Info" />
                </p>
              </Col>
              <Col xs={12} md={12} lg={12} className="text-right">
                <Space>
                  <Button type="primary" onClick={setOpenQuoteModel}>
                    <PlusCircleOutlined />
                    <FormattedMessage id="AddEstimate.AddEstimate" />
                  </Button>
                </Space>
              </Col>
            </Row>
          </div>
          <QuotesList />
          {openQuoteModel && (
            <CreateQuote
              open={openQuoteModel}
              onCancel={() => setOpenQuoteModel(false)}
            />
          )}
        </div>
      </div>
    </>
  );
}
export default Quotes;
